var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClusterQueues = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.00024 12C3.55253 12 4.00024 12.4477 4.00024 13V17C4.00024 17.5523 4.44796 18 5.00024 18H17.0002C17.5525 18 18.0002 17.5523 18.0002 17V13C18.0002 12.4477 18.448 12 19.0002 12C19.5525 12 20.0002 12.4477 20.0002 13V17C20.0002 18.6569 18.6571 20 17.0002 20H5.00024C3.34339 20 2.00024 18.6569 2.00024 17V13C2.00024 12.4477 2.44796 12 3.00024 12Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.00024 2C7.55253 2 8.00024 2.44772 8.00024 3L8.00024 15C8.00024 15.5523 7.55253 16 7.00024 16C6.44796 16 6.00024 15.5523 6.00024 15L6.00024 3C6.00024 2.44772 6.44796 2 7.00024 2Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.0002 2C11.5525 2 12.0002 2.44772 12.0002 3L12.0002 15C12.0002 15.5523 11.5525 16 11.0002 16C10.448 16 10.0002 15.5523 10.0002 15L10.0002 3C10.0002 2.44772 10.448 2 11.0002 2Z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.0002 2C15.5525 2 16.0002 2.44772 16.0002 3L16.0002 15C16.0002 15.5523 15.5525 16 15.0002 16C14.448 16 14.0002 15.5523 14.0002 15L14.0002 3C14.0002 2.44772 14.448 2 15.0002 2Z",
  fill: "currentColor"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.82835 5.20708C1.82835 4.76163 2.36692 4.53855 2.6819 4.85353L4.65677 6.8284L2.6819 8.80328C2.36692 9.11826 1.82835 8.89518 1.82835 8.44972V6.8284L1.82835 5.20708Z",
  fill: "currentColor"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.82835 6.41419V7.24262L3.24256 6.8284L2.82835 6.41419ZM2.6819 4.85353C2.36692 4.53855 1.82835 4.76163 1.82835 5.20708L1.82835 8.44972C1.82835 8.89518 2.36692 9.11826 2.6819 8.80328L4.65677 6.8284L2.6819 4.85353Z",
  fill: "currentColor"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8287 5.20708C17.8287 4.76163 18.3673 4.53855 18.6823 4.85353L20.6571 6.8284L18.6823 8.80328C18.3673 9.11826 17.8287 8.89518 17.8287 8.44972V6.8284L17.8287 5.20708Z",
  fill: "currentColor"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.8287 6.41419V7.24262L19.2429 6.8284L18.8287 6.41419ZM18.6823 4.85353C18.3673 4.53855 17.8287 4.76163 17.8287 5.20708L17.8287 8.44972C17.8287 8.89518 18.3673 9.11826 18.6823 8.80328L20.6571 6.8284L18.6823 4.85353Z",
  fill: "currentColor"
})));
export default SvgClusterQueues;